import { Discovery } from '../types';

export const discoveries: Discovery[] = [
  {
    title: 'Conexões Matemáticas Profundas',
    description: 'Identificamos estruturas matemáticas comuns que permeiam diferentes teorias físicas:',
    items: [
      'Teoria de Gauge: Demonstramos como o eletromagnetismo, a teoria eletrofraca e a cromodinâmica quântica podem ser unificados através do formalismo de teoria de gauge, com diferentes grupos de simetria.',
      'Geometria Diferencial: Estabelecemos conexões entre a formulação hamiltoniana da mecânica clássica, a estrutura de espaço-tempo da relatividade geral e a geometria de fibrados principais em teorias de gauge.',
      'Teoria da Informação: Revelamos como conceitos de entropia e informação conectam a termodinâmica, a mecânica estatística e aspectos fundamentais da mecânica quântica.'
    ]
  },
  {
    title: 'Regimes de Transição',
    description: 'Nossas simulações computacionais permitiram explorar os regimes de transição entre diferentes teorias, revelando comportamentos emergentes não evidentes nas formulações analíticas:',
    items: [
      'Transição Clássico-Quântica: Identificamos padrões específicos de decoerência que governam a emergência do comportamento clássico a partir do substrato quântico.',
      'Limite Newtoniano da Relatividade Geral: Caracterizamos precisamente as condições sob as quais a Relatividade Geral se reduz à gravitação newtoniana.',
      'Transições de Fase Cosmológicas: Modelamos as transições de fase no universo primordial, revelando como quebras de simetria sucessivas podem ter gerado as forças fundamentais e partículas que observamos hoje.'
    ]
  },
  {
    title: 'Inconsistências Fundamentais',
    description: 'Nossa análise crítica identificou inconsistências fundamentais que apontam para a necessidade de novas teorias físicas:',
    items: [
      'Incompatibilidade Quântico-Gravitacional: Demonstramos matematicamente como a natureza geométrica contínua do espaço-tempo na Relatividade Geral é fundamentalmente incompatível com a natureza discreta e probabilística da mecânica quântica.',
      'Problema da Constante Cosmológica: Quantificamos precisamente a discrepância entre o valor observado da constante cosmológica e as previsões da teoria quântica de campos.',
      'Assimetria Matéria-Antimatéria: Mostramos que a violação CP no Modelo Padrão é insuficiente para explicar a predominância de matéria sobre antimatéria no universo.'
    ]
  },
  {
    title: 'Perspectivas Futuras',
    description: 'Com base em nossas análises, identificamos direções promissoras para pesquisas futuras:',
    items: [
      'Gravidade Quântica: Desenvolvimento de teorias como cordas e gravidade quântica em loop para reconciliar a mecânica quântica com a relatividade geral.',
      'Teorias de Grande Unificação: Extensões do Modelo Padrão que unificam as forças fundamentais em energias extremamente altas.',
      'Cosmologia Quântica: Modelos que aplicam princípios quânticos ao universo como um todo, potencialmente explicando a singularidade inicial.',
      'Termodinâmica Quântica de Não-Equilíbrio: Desenvolvimento de um framework para sistemas quânticos complexos fora do equilíbrio.'
    ]
  }
];